<template>
  <div ref="seriesRoot" class="series-new-host">
  <section v-if="isReady && seriesSlides.length" class="series-new" id="series-new">
    <div class="series-new__block">
      <div class="series-new-head mobile-hidden">
        <div class="series-new-head__title">Pulpy знает, как встряхнуть<br> неловкость в любой<br> ситуации</div>
      </div>

      <div class="series-new__frame-wrap">
        <button
          ref="mainPrev"
          type="button"
          class="series-new__frame-nav series-new__frame-nav--prev"
          aria-label="Предыдущее видео"
        >
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <circle cx="20" cy="20" r="20" fill="black" fill-opacity="0.2"/>
            <path d="M22.9167 13.333L16.25 19.9997L22.9167 26.6663" stroke="white" stroke-width="3"/>
          </svg>
        </button>

        <div class="series-new__frame" :class="{ 'series-new__frame--playing': isVideoPlaying }">
          <swiper
            class="series-new-swiper"
            :modules="modules"
            :slides-per-view="1"
            :space-between="0"
            :loop="false"
            :thumbs="{ swiper: thumbsSwiper }"
            :no-swiping-selector="'.series-new-swiper__media'"
            :prevent-clicks="false"
            :prevent-clicks-propagation="false"
            :allow-touch-move="!isVideoPlaying"
            :simulate-touch="!isVideoPlaying"
            :touch-start-prevent-default="false"
            :navigation="{
              prevEl: mainPrev,
              nextEl: mainNext,
            }"
            @swiper="setMainSwiper"
            @slideChange="onMainSlideChange"
          >
            <template #wrapper-start>
              <swiper-slide
                v-for="item in seriesSlides"
                :key="item.id"
              >
                <video
                  v-if="item.type === 'native'"
                  class="series-new-swiper__media series-new-swiper__video swiper-no-swiping"
                  :src="item.src"
                  :poster="item.img || null"
                  controls
                  playsinline
                  preload="metadata"
                  @play="onNativeVideoPlay"
                  @pause="onNativeVideoPause"
                  @ended="onNativeVideoPause"
                ></video>
                <iframe
                  v-else-if="item.type === 'vk'"
                  class="series-new-swiper__media series-new-swiper__iframe swiper-no-swiping"
                  :src="vkEmbedSrc(item.src)"
                  :data-base-src="vkEmbedSrc(item.src)"
                  width="853"
                  height="480"
                  allow="autoplay; encrypted-media; fullscreen; picture-in-picture; screen-wake-lock;"
                  frameborder="0"
                  allowfullscreen
                ></iframe>
              </swiper-slide>
            </template>
          </swiper>
          <button
            v-if="!isVideoPlaying"
            type="button"
            class="series-new__frame-cover"
            aria-label="Воспроизвести видео"
            @click.stop.prevent="onCoverPlayClick"
          >
            <span class="series-new__frame-play"></span>
          </button>
        </div>

        <button
          ref="mainNext"
          type="button"
          class="series-new__frame-nav series-new__frame-nav--next"
          aria-label="Следующее видео"
        >
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <circle cx="20" cy="20" r="20" transform="matrix(-1 0 0 1 40 0)" fill="black" fill-opacity="0.2"/>
            <path d="M17.0833 13.333L23.75 19.9997L17.0833 26.6663" stroke="white" stroke-width="3"/>
          </svg>
        </button>
      </div>
      <swiper
        class="series-new-swiper-thumbs"
        :modules="modules"
        @swiper="setThumbsSwiper"
        :navigation="{
          prevEl: prev,
          nextEl: next,
        }"
        slidesPerView="3"
        :spaceBetween="20"
        :breakpoints="{ 768:{ slidesPerView:3 }, 900:{ slidesPerView:6, } }"
        :centeredSlides="false"
        :loop="false"
        :slideToClickedSlide="true"
        ref="swiper"
      >
        <template #wrapper-start>
          <swiper-slide
            v-for="item in seriesSlides"
            :key="item.id"
          >
            <img
              v-if="item.img"
              :src="item.img"
              class="series-new-swiper-thumbs__img"
              :alt="item.name"
            >
            <span>{{ item.name }}</span>
          </swiper-slide>
        </template>
      </swiper>
      <div class="series-new-navigation">
        <div ref="prev" class="series-new-navigation-prev">
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="20" cy="20" r="20" fill="black" fill-opacity="0.2"/>
            <path d="M22.9167 13.333L16.25 19.9997L22.9167 26.6663" stroke="white" stroke-width="3"/>
          </svg>
        </div>
        <div ref="next" class="series-new-navigation-next">
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="20" cy="20" r="20" transform="matrix(-1 0 0 1 40 0)" fill="black" fill-opacity="0.2"/>
            <path d="M17.0833 13.333L23.75 19.9997L17.0833 26.6663" stroke="white" stroke-width="3"/>
          </svg>
        </div>
      </div>
    </div>
  </section>
  </div>
</template>

<script>
import { ref } from 'vue';

import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Thumbs } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

export default {
  components: { Swiper, SwiperSlide },
  name: 'SeriesBlockNew',
  setup() {
    const mainPrev = ref(null);
    const mainNext = ref(null);
    const prev = ref(null);
    const next = ref(null);
    return {
      modules: [Navigation, Thumbs],
      mainPrev,
      mainNext,
      prev,
      next,
    };
  },
  computed: {
    seriesSlides() {
      const items = this.$store.getters.serieses || [];

      return items
        .map((item) => this.mapSeriesItem(item))
        .filter((item) => item && item.src);
    },
  },
  data() {
    return {
      isReady: false,
      thumbsSwiper: null,
      mainSwiper: null,
      isVideoPlaying: false,
    };
  },

  watch: {
    seriesSlides() {
      this.setVideoPlaying(false);
    },
    isVideoPlaying(isPlaying) {
      if (!this.mainSwiper) {
        return;
      }

      this.mainSwiper.allowTouchMove = !isPlaying;
      this.mainSwiper.params.simulateTouch = !isPlaying;
      this.mainSwiper.update();
    },
  },

  methods: {
    mapSeriesItem(item) {
      if (!item || !item.attributes) {
        return null;
      }

      const { name, preview, video, videoFile } = item.attributes;
      const nativeSrc = this.resolveMediaUrl(videoFile);
      const vkSrc = this.extractVideoSrc(video);

      if (!nativeSrc && !vkSrc) {
        return null;
      }

      return {
        id: item.id,
        name: name || '',
        type: nativeSrc ? 'native' : 'vk',
        src: nativeSrc || vkSrc,
        img: this.resolveMediaUrl(preview),
      };
    },
    extractVideoSrc(video) {
      if (!video || typeof video !== 'string') {
        return '';
      }

      const trimmed = video.trim();

      if (!trimmed) {
        return '';
      }

      if (/^https?:\/\//i.test(trimmed)) {
        return trimmed;
      }

      const srcMatch = trimmed.match(/src=["']([^"']+)["']/i);

      return srcMatch ? srcMatch[1] : '';
    },
    vkEmbedSrc(src) {
      if (!src) {
        return '';
      }

      try {
        const url = new URL(src, window.location.href);
        url.searchParams.set('js_api', '1');
        return url.toString();
      } catch (e) {
        return src;
      }
    },
    resolveMediaUrl(media) {
      const url = media && media.data && media.data.attributes && media.data.attributes.url;

      if (!url) {
        return '';
      }

      if (/^https?:\/\//i.test(url)) {
        return url;
      }

      return this.$store.getters.staticUrl + url;
    },
    setThumbsSwiper(swiper) {
      this.thumbsSwiper = swiper;
    },
    setMainSwiper(swiper) {
      this.mainSwiper = swiper;
    },
    setVideoPlaying(isPlaying) {
      this.isVideoPlaying = isPlaying;
    },
    getSeriesRoot() {
      const root = this.$refs.seriesRoot;

      if (!root || typeof root.querySelectorAll !== 'function') {
        return null;
      }

      return root;
    },
    getVideos() {
      const root = this.getSeriesRoot();

      if (!root) {
        return [];
      }

      return Array.from(root.querySelectorAll('.series-new-swiper video'));
    },
    getActiveVideo() {
      const root = this.getSeriesRoot();

      if (!root) {
        return null;
      }

      return (
        root.querySelector('.series-new-swiper .swiper-slide-active video')
        || root.querySelector('.series-new-swiper video')
      );
    },
    getVkIframes() {
      const root = this.getSeriesRoot();

      if (!root) {
        return [];
      }

      return Array.from(root.querySelectorAll('.series-new-swiper iframe'));
    },
    getActiveVkIframe() {
      const root = this.getSeriesRoot();

      if (!root) {
        return null;
      }

      return (
        root.querySelector('.series-new-swiper .swiper-slide-active iframe')
        || root.querySelector('.series-new-swiper iframe')
      );
    },
    pauseInactiveVideos(activeVideo = null) {
      this.getVideos().forEach((video) => {
        if (video === activeVideo || video.paused) {
          return;
        }

        video.pause();
      });
    },
    async onCoverPlayClick() {
      const video = this.getActiveVideo();

      if (!video) {
        this.startActiveVkVideo();
        return;
      }

      this.pauseInactiveVideos(video);

      try {
        await video.play();
        this.setVideoPlaying(true);
      } catch (e) {
        video.controls = true;
      }
    },
    startActiveVkVideo() {
      const iframe = this.getActiveVkIframe();

      if (!iframe) {
        return;
      }

      try {
        const url = new URL(iframe.dataset.baseSrc || iframe.src, window.location.href);
        url.searchParams.set('autoplay', '1');
        url.searchParams.set('js_api', '1');
        iframe.src = url.toString();
      } catch (e) {
        iframe.src = iframe.dataset.baseSrc || iframe.src;
      }

      this.setVideoPlaying(true);
    },
    resetVkIframes() {
      this.getVkIframes().forEach((iframe) => {
        const baseSrc = iframe.dataset.baseSrc;

        if (baseSrc && iframe.src !== baseSrc) {
          iframe.src = baseSrc;
        }
      });
    },
    onNativeVideoPlay(event) {
      this.pauseInactiveVideos(event.target);
      this.setVideoPlaying(true);
    },
    onNativeVideoPause() {
      const hasPlayingVideo = this.getVideos().some((video) => !video.paused && !video.ended);
      this.setVideoPlaying(hasPlayingVideo);
    },
    onMainSlideChange() {
      this.pauseInactiveVideos();
      this.resetVkIframes();
      this.setVideoPlaying(false);
    },
  },
  async mounted() {
    await this.$store.dispatch('getSerieses');
    this.isReady = true;
  },
  beforeDestroy() {
    this.pauseInactiveVideos();
    this.resetVkIframes();
  },
};
</script>

<style lang="scss">
@import 'series-new';

p {
  white-space: pre-wrap;
}
</style>
